import { STORE } from "../../data/store";

const LINKS = [
  { label: "Productos", href: "#productos" },
  { label: "Nosotros", href: "#nosotros" },
  { label: "Testimonios", href: "#testimonios" },
  { label: "Galería", href: "#galeria" },
  { label: "Contacto", href: "#contacto" },
];

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0A0908] border-t border-white/5 py-14"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
        <div>
          <p className="font-serif text-xl font-black text-[#F5F0E6]">
            EL NAVEGANTE{" "}
            <span className="text-[#C89B3C] italic">Wester</span>
          </p>
          <p className="text-sm text-[#8A7D71] mt-2">
            {STORE.addressLine1}, {STORE.addressLine2}
          </p>
        </div>

        <nav className="flex flex-wrap gap-x-8 gap-y-3">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`footer-link-${l.href.replace("#", "")}`}
              className="text-sm uppercase tracking-widest text-[#B8A99A] hover:text-[#C89B3C] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>
      </div>

      <div className="mx-auto max-w-7xl px-6 md:px-12 mt-10 pt-8 border-t border-white/5">
        <p className="text-xs text-[#8A7D71]">
          © {new Date().getFullYear()} El Navegante Wester. Estilo vaquero
          auténtico en Hollister, California.
        </p>
      </div>
    </footer>
  );
};
